import { gql } from '@apollo/client';

// ==================== QUERIES ====================

export const GET_SALES_TARGET_CONFIG = gql`
  query GetSalesTargetConfig {
    getSalesTargetConfig {
      id
      defaultAmount
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_SALES_TARGET_OVERRIDES = gql`
  query GetAllSalesTargetOverrides {
    getAllSalesTargetOverrides {
      id
      startDate
      endDate
      amount
      description
      createdAt
      updatedAt
    }
  }
`;

export const GET_AMOUNT_FOR_DATE = gql`
  query GetAmountForDate($date: DateTime!) {
    getAmountForDate(date: $date) {
      amount
      isOverride
      override {
        id
        startDate
        endDate
        amount
        description
      }
    }
  }
`;

export const GET_SALES_CALENDAR = gql`
  query GetSalesCalendar($startDate: DateTime!, $endDate: DateTime!) {
    getSalesCalendar(startDate: $startDate, endDate: $endDate) {
      date
      amount
      isOverride
      description
    }
  }
`;

// ==================== MUTATIONS ====================

export const UPDATE_DEFAULT_SALES_AMOUNT = gql`
  mutation UpdateDefaultSalesAmount($amount: Float!) {
    updateDefaultSalesAmount(amount: $amount) {
      id
      defaultAmount
      updatedAt
    }
  }
`;

export const CREATE_SALES_TARGET_OVERRIDE = gql`
  mutation CreateSalesTargetOverride($input: CreateOverrideInput!) {
    createSalesTargetOverride(input: $input) {
      id
      startDate
      endDate
      amount
      description
      createdAt
    }
  }
`;

export const UPDATE_SALES_TARGET_OVERRIDE = gql`
  mutation UpdateSalesTargetOverride($input: UpdateOverrideInput!) {
    updateSalesTargetOverride(input: $input) {
      id
      startDate
      endDate
      amount
      description
      updatedAt
    }
  }
`;

export const DELETE_SALES_TARGET_OVERRIDE = gql`
  mutation DeleteSalesTargetOverride($id: ID!) {
    deleteSalesTargetOverride(id: $id)
  }
`;
